import "css!js/file_viewer/loading_indicator/loading_indicator.module.out.css";
export const loadingContent = "_loadingContent_5g6od_1";
const classes = { "loadingContent": "_loadingContent_5g6od_1" };
export default classes;
//# sourceMappingURL=loading_indicator.module.css.preenvesnextjs.map
